<div class="panel">
    @if(title){
        <div class="title-text panel-header">
            {{ title }}
        </div>
    }
    <div class="form-container">
        <ng-content></ng-content>
    </div>
</div>
